import React from 'react';
import DeliveryAddressDescription from '../Cart/DeliveryAddressDescription';

function Address() {
  return <DeliveryAddressDescription />;
}

export default Address;
